import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext, useEffect } from 'react';
import { formStateRefs } from '../../context';
export var useFieldRegisterHook = function useFieldRegisterHook(name, setFailure, focus, ready, failed) {
  if (!name) {
    // TODO: remove me in the bright future
    throw new Error('provided an empty name');
  }
  var _useContext = useContext(formStateRefs),
    _useContext2 = _slicedToArray(_useContext, 2),
    setField = _useContext2[1];
  useEffect(function () {
    setField(name, {
      setFailure: setFailure,
      focus: focus,
      ready: ready,
      failed: failed
    });
  }, [name, setFailure, focus, setField, ready, failed]);
};